import React, { useState, useEffect } from "react";
import { getGLedger } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import { getAllGeneralLedger } from "../../../api/endpoints/search";
import { Select } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";

const { Option } = Select;

const GLedger = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [state, setState] = useState({
    ledgerCodes: [],
    enteredOn: "",
    startingDate: "",
    glCode: "",
    glDescription: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  const clearFields = () => {
    setState({
      ledgerCodes: state.ledgerCodes,
      glCode: "",
      glDescription: "",
      enteredOn: "",
      startingDate: "",
    });
  };

  const [loading, setLoading] = useState(false);
  const editHandler = async (e) => {
    if (!state.startingDate && !state.enteredOn)
      return message.error("Please type date !");
    if (!state.glCode) return message.error("Please type Ledger Code !");
    let data = {
      enteredOn: state.enteredOn,
      startingDate: state.startingDate,
      glCode: state.glCode,
      siteId: Number(user.siteId),
    };

    try {
      setLoading(true); // disable button
      const results = await getGLedger(data, access_token);
      if (results.data.length === 0) {
        message.error("No Record Found in this date");
      }
      if (results.success) {
        const payload = results.data.reduce((acc, curr) => {
          return [
            ...acc,
            {
              enteredOn: curr.enteredOn,
              generalLedgerCode: Number(curr.generalLedgerCode),
              generalLedgerDescription: curr.generalLedgerDescription,
              description: curr.description,
              voucherNumber: curr.voucherNumber,
              voucherType: curr.voucherType,
              debit: curr.debit,
              credit: curr.credit,
              siteId: curr.siteId,
              printOrder: curr.printOrder,
            },
          ];
        }, []);
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const getAllData = async () => {
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();
    getName();
  }, []);

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    // ====== Header ======
    const now = new Date();
    const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    doc.setFontSize(8);
    doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
    doc.setFontSize(16);
    doc.text(`${siteName}`, 103, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(`${siteAddress}`, 103, 16, { align: "center" });
    doc.setFontSize(10);
    doc.text(
      `${state.glDescription} From: ${formatDate(
        state.startingDate
      )} To ${formatDate(state.enteredOn)}`,
      103,
      20,
      {
        align: "center",
      }
    );

    // ====== Helper: DR/CR format ======
    const formatBalance = (bal) => {
      if (bal > 0)
        return `${bal.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} DR`;
      if (bal < 0)
        return `${Math.abs(bal).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} CR`;
      return "0.00";
    };

    // ====== Opening Balance ======
    const openingBalance = data
      .filter((r) => r.printOrder === 0)
      .reduce(
        (sum, r) => sum + (Number(r.debit) || 0) - (Number(r.credit) || 0),
        0
      );

    const tableRows = [];
    let runningBalance = openingBalance;

    // First row: Opening Balance
    tableRows.push([
      "", // Date
      "", // VNO
      "", // VType
      "Opening Balance",
      openingBalance > 0 ? openingBalance.toLocaleString() : "",
      openingBalance < 0 ? Math.abs(openingBalance).toLocaleString() : "",
      formatBalance(runningBalance),
    ]);

    // ====== Remaining Records ======
    const otherRows = data
      .filter((r) => r.printOrder !== 0)
      .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn));

    otherRows.forEach((r) => {
      const debit = Number(r.debit) || 0;
      const credit = Number(r.credit) || 0;
      runningBalance += debit - credit;

      tableRows.push([
        r.enteredOn ? formatDateDDMMYYYY(r.enteredOn) : "",
        r.voucherNumber || "",
        r.voucherType || "",
        r.description || "",
        debit.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        credit.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        formatBalance(runningBalance),
      ]);
    });

    const totalDebit = otherRows.reduce(
      (sum, r) => sum + (Number(r.debit) || 0),
      0
    );
    const totalCredit = otherRows.reduce(
      (sum, r) => sum + (Number(r.credit) || 0),
      0
    );

    tableRows.push([
      "",
      "",
      "",
      "Total",
      totalDebit.toLocaleString(),
      totalCredit.toLocaleString(),
      formatBalance(runningBalance),
    ]);

    // ====== Render AutoTable ======
    autoTable(doc, {
      head: [
        ["Date", "VNO", "VT", "Description", "Debit", "Credit", "Balance"],
      ],
      body: tableRows,
      startY: 25,
      theme: "grid",
      margin: { left: 1, right: 2 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 16 },
        1: { halign: "center", cellWidth: 13 },
        2: { halign: "center", cellWidth: 8 },
        3: { halign: "left", cellWidth: 95 },
        4: { halign: "right", cellWidth: 23 },
        5: { halign: "right", cellWidth: 23 },
        6: { halign: "right", cellWidth: 29 },
      },
      didParseCell: (data) => {
        // Make last row (Total) bold
        if (data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    // ====== Open PDF in new tab ======
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-10">
            <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">General Ledger</h1>
              </div>
              <div className="flex flex-col h-40 content-center items-center justify-items-center justify-evenly">
                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-white" htmlFor="startDate">
                      Starting Date:
                    </label>
                    <input
                      type="date"
                      name="startingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                    <label className="text-white ml-5" htmlFor="endDate">
                      Ending Date:
                    </label>
                    <input
                      type="date"
                      name="enteredOn"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option
                        value={el.generalLedgerCode}
                        key={el.generalLedgerCode}
                      >
                        {el.generalLedgerCode}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option
                        value={el.generalLedgerCode}
                        key={el.generalLedgerCode}
                      >
                        {`${el.generalLedgerCode} - ${el.description}`}
                      </Option>
                    ))}
                  </Select>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button
                    onClick={clearFields}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GLedger;
